import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Tram = function Tram(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m18.5 3-.9865-.4933c-.378-.189-.567-.2834-.765-.35a3 3 0 0 0-.5408-.1277C16.0008 2 15.7895 2 15.3669 2H8.6331c-.4226 0-.6339 0-.8408.029a3 3 0 0 0-.5408.1276c-.198.0667-.387.1612-.765.3501L5.5 3M11 6 9 2m4 4 2-4M4 13h16m-3 7 1 2M7 20l-.9998 2M8.5 16.5h.01m6.99 0h.01M8.8 20h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 17.7202 20 16.8802 20 15.2v-4.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 6 16.8802 6 15.2 6H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 8.2798 4 9.1198 4 10.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 20 7.1198 20 8.8 20m.2-3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m7 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 16 16.5"
    })
  }));
};
export default Tram;